<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>Publishers</h1>
      <Notification :notify="notify" />
      <PublicationList ref="publicationList" />

      <div v-show="isEdit">
        <v-form ref="form" v-model="valid" lazy-validation>
          <div class="row">
            <div class="col">
              <v-text-field
                id="publisherName"
                label="Name *"
                v-model="selectedObj.Name"
                :rules="PublisherRules"
                required
              ></v-text-field>
            </div>
            <div class="col">
              <v-text-field
                id="publisherAddress"
                label="Address"
                v-model="selectedObj.Address"
                required
              ></v-text-field>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <v-select
                id="Country"
                v-model="selectedObj.country"
                :items="countries"
                label="Country"
                item-text="CountryName"
                item-value="id"
                return-object
              ></v-select>
            </div>
            <div class="col">
              <v-text-field
                id="publisherPhone"
                label="Phone"
                v-model="selectedObj.phone"
                required
              ></v-text-field>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <v-text-field
                id="publisherWebsite"
                v-model="selectedObj.website"
                label="Website"
                required
              ></v-text-field>
            </div>
            <div class="col">
            </div>
          </div>
          <v-divider></v-divider>
          <h4 class="pt-5">Contact Person</h4>
          <br>
          <div class="row">
            <div class="col">
              <v-text-field
                id="contactPersonName"
                v-model="selectedObj.contactPersonName"
                label="Name"
              ></v-text-field>
            </div>
            <div class="col">
              <v-text-field
                id="contactPersonRole"
                v-model="selectedObj.contactPersonRole"
                label="Role"
              ></v-text-field>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <v-text-field
                id="contactPersonEmail"
                v-model="selectedObj.contactPersonEmail"
                label="Email"
              ></v-text-field>
            </div>
            <div class="col">
              <v-text-field
                id="contactPersonPhone"
                v-model="selectedObj.contactPersonPhone"
                label="Phone"
              ></v-text-field>
            </div>
          </div>
          <v-divider  class="pt-5"></v-divider>
          <div class="row mb-4">
            <div class="col">
              <div class="float-right action-area">
                <v-btn @click="()=>{this.isEdit = false}" id="btnCancel"> Cancel </v-btn>
                <v-btn
                  id="btnSave"
                  class="mr-4"
                  color="primary"
                  @click="onSave()"
                  :loading="loading"
                  :disabled="loading"
                >
                  Save
                </v-btn>
              </div>
            </div>
          </div>
        </v-form>
        <ConfirmationDialog ref="confirm" />
      </div>

      <div class="row" v-show="!isEdit">
        <div class="pl-3 col">
          <v-text-field
            id="textSearch"
            v-model="Search"
            label="Search"
            required
            append-outer-icon="mdi-table-search"
            @click:append-outer="onSearch"
            v-on:keyup.enter="onSearch()"
          ></v-text-field>
        </div>
        <div class="col">
          <v-select
            id="subscriptionType"
            v-model="paging.isASC"
            :items="[{type:'Ascending', value: true}, {type:'Descending', value: false}]"
            label="Order By"
            item-text="type"
            item-value="value"
            return-value="type"
            @change="getPublisherByPagin()"
          ></v-select>
        </div>
        <div class="col">
          <div class="float-right">
            <v-btn color="primary" @click="onNew()" class="mt-4" id="btnNew">
              New Publisher
            </v-btn>
          </div>
        </div>
      </div>
      <div class="row mt-5" v-show="!isEdit">
        <div class="col">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" @click="sortPublisherName" style="cursor: pointer;">Publisher Name</th>
                  <th class="text-left" @click="sortAddress" style="cursor: pointer;">Address</th>
                  <th class="text-left" @click="sortCountry" style="cursor: pointer;">Country</th>
                  <th class="text-left" @click="sortWebsite" style="cursor: pointer;">Website</th>
                  <th style="width: 150px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.id" :id="'svg' + i">
                  <td>{{ item.Name }}</td>
                  <td>{{ item.Address }}</td>
                  <td>
                    {{ item.country != null ? item.country.CountryName : "" }}
                  </td>
                  <td>{{ item.website }}</td>
                  <!---->
                  <td>
                    <v-icon class="mr-2 icon-edit" @click="onEdit(item)"
                      >mdi-comment-edit</v-icon
                    >
                    <v-icon class="mr-2 icon-delete" @click="onDelete(item)"
                      >mdi-delete</v-icon
                    >
                    <!-- <v-btn @click="getPublicationList(item.Name)" id="btnPublications"> ebooks </v-btn> -->
                    <v-icon
                          class="mr-2"
                          @click="getPublicationList(item.Name)">
                          mdi-view-grid-outline
                    </v-icon>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <div class="row" v-show="!isEdit">
        <div class="col">
          <Pagination :paging="paging" v-on:next="onNextPage" />
        </div>
      </div>
      <v-overlay :value="overlay">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </v-card>
    <!--------------------------->
  </div>
</template>

<script>
import * as api from "@/api";
import Notification from "@/components/Notification";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import Pagination from "@/components/Pagination";
import PublicationList from "../components/PublicationList.vue";
import { valid } from "semver";

export default {
  name: "Publishers",
  components: {
    Notification,
    Pagination,
    ConfirmationDialog,
    PublicationList,
  },
  created() {
    this.getCountries();
    this.getPublisherByPagin();
  },
  computed: {
  },
  methods: {
    getCountries() {
      this.countries = [];
      new Promise((resolve, reject) => {
        api
          .getAll("country")
          .then((response) => {
            console.log(response.data);
            this.countries = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onSearch() {
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getPublisherByPagin();
    },
    onNextPage(page) {
      this.paging.page = page;
      this.paging.keyword = this.Search;
      this.getPublisherByPagin();
    },
    getPublisherByPagin() {
      let that = this;
      that.overlay = true
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getByPagin("publisher", this.paging)
          .then((response) => {
            that.overlay = false
            console.log(response.data.data);
            this.list = response.data.data;
            this.paging.count = response.data.count;
          })
          .catch((error) => {
            that.overlay = false
            reject(error);
          });
      });
    },
    onNew() {
      this.isEdit = true;
      this.id = 0;
      this.selectedObj.Name = "";
      this.selectedObj.Address = "";
      this.selectedObj.website = "";
      this.selectedObj.phone = "";
      this.selectedObj.contactPersonName = "";
      this.selectedObj.contactPersonRole = "";
      this.selectedObj.contactPersonEmail = "";
      this.selectedObj.contactPersonPhone = "";
      this.valid = false;
      this.selectedObj.id = 0;
    },
    onSave() {
      let that = this;
      that.overlay = true
      this.$refs.form.validate();
      console.log(this.valid);
      if (!this.valid) {
        that.overlay = false;
        return;
      }
      that.id = this.selectedObj.id;
      new Promise((resolve, reject) => {
        api
          .update("publisher", this.selectedObj)
          .then((response) => {
            resolve(response);
            console.log(response.status);
            console.log(response);
            if (response.status === 200 || response.status === 201) {
              this.notify.type = 1;
              if (that.id == 0) {
                this.notify.message = "Record successfully created.";
              } else {
                this.notify.message = "Record successfully updated.";
              }
              this.getPublisherByPagin();
              setTimeout(() => {
                this.notify.type = 0;
              }, 3000);
              return response;
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data.");
            }
            // that.overlay = false
          })
          .catch((error) => {
            if (error.response.status == 409) {
              this.notify.type = 4;
              this.notify.errors.push("Publisher name already exist");
              this.loading = false;
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            }
            that.overlay = false
          });
      });

      this.isEdit = false;
      this.$refs.form.reset();
    },
    onEdit(obj) {
      this.isEdit = true;
      this.selectedObj = Object.assign({}, obj);
    },
    async onDelete(obj) {
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure, Do you really want to delete this record?"
        )
      ) {
        new Promise((resolve, reject) => {
          api
            .DeleteByID("publisher", obj.id)
            .then((response) => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.notify.message = "Record successfully deleted";
                setTimeout(() => {
                  this.notify.type = 0;
                  this.getPublisherByPagin();
                }, 3000);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
              }
            })
            .catch((error) => {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            });
        });
      }

      this.isEdit = false;
    },
    onCancel() {
      this.isEdit = false;
      this.$refs.form.reset();
    },
    getPublishers() {
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getAll("publisher")
          .then((response) => {
            this.list = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getPublicationList(name) {
      new Promise((resolve, reject) => {
        api
          .getAll(`publications/${name}/publications`)
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              this.$refs.publicationList.open(response.data);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    sortPublisherName() {
      this.publisherNameSortAsc = !this.publisherNameSortAsc;
      this.list = this.list.sort((a, b) => this.publisherNameSortAsc ? a.Name.localeCompare(b.Name) : b.Name.localeCompare(a.Name));
    },
    sortAddress() {
      this.addressSortAsc = !this.addressSortAsc;
      this.list = this.list.sort((a, b) => this.addressSortAsc ? a.Address.localeCompare(b.Address) : b.Address.localeCompare(a.Address));
    },
    sortCountry() {
      this.countrySortAsc = !this.countrySortAsc;
      this.list = this.list.sort((a, b) => this.countrySortAsc ? a.Country.localeCompare(b.Country) : b.Country.localeCompare(a.Country));
    },
    sortWebsite() {
      this.websiteSortAsc = !this.websiteSortAsc;
      this.list = this.list.sort((a, b) => this.websiteSortAsc ? a.Website.localeCompare(b.Website) : b.Website.localeCompare(a.Website));
    }
  },
  data() {
    return {
      id: 0,
      isEdit: false,
      list: [],
      selectedObj: {
        id: 0,
        Name: "",
        Address: "",
        phone: "",
        website: "",
        contactPersonName: "",
        contactPersonRole: "",
        contactPersonEmail: "",
        contactPersonPhone: "",
      },
      Name: "",
      Address: "",
      phone: "",
      website: "",
      contactPersonName: "",
      contactPersonRole: "",
      contactPersonEmail: "",
      contactPersonPhone: "",
      listMataData: [],
      Search: "",
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      PublisherRules: [(v) => !!v || "Publisher Name is required"],
      valid: false,
      dialog: false,
      paging: { count: 10, page: 1, size: 10, keyword: "", isASC: true },
      overlay : false
    };
  },
};
</script>
<style scoped>
.check-select {
  margin-top: -15px !important;
  margin-bottom: -15px !important;
}
</style>


// WEBPACK FOOTER //
// src/views/Publisher.vue